import { backendVersion, merchantInstance, dineInAxios } from "@/axios-path.js";
export default {
  namespaced: true,
  state: {
    store_approve_list: [],
    contact_store_approve_list: [],
    edit_store_approve_list: [],
    documentList: [],
    documentDetail: {},
    eventLogApproval: [],
    storeStatusList: [],
    dine_in_store_list: [],
    merchant_user: [],
  },
  mutations: {
    resetState(state) {
      state.store_approve_list = [];
    },
    getStoreApproveList(state, data) {
      state.store_approve_list = data;
    },
    getContactApproveList(state, data) {
      state.contact_store_approve_list = data;
    },
    approveContactOldStore(state, form) {
      let index = state.contact_store_approve_list.findIndex(
        (val) => val.contact_id == form.contact_id
      );
      state.contact_store_approve_list.splice(index, 1);
    },
    approveContactNewStore(state, form) {
      let index = state.contact_store_approve_list.findIndex(
        (val) => val.contact_id == form.contact_id
      );
      state.contact_store_approve_list.splice(index, 1);
    },
    deleteContactStore(state, contact_id) {
      let index = state.contact_store_approve_list.findIndex(
        (val) => val.contact_id == contact_id
      );
      state.contact_store_approve_list.splice(index, 1);
    },
    approveStoreApprove(state, form) {
      let index = state.store_approve_list.findIndex(
        (val) => val.store_id == form.store_id
      );
      state.store_approve_list.splice(index, 1);
    },
    deleteStoreApproveByID(state, store_id) {
      let index = state.edit_store_approve_list.findIndex(
        (val) => val.store_edit_id == store_id
      );
      state.edit_store_approve_list.splice(index, 1);
    },
    getEditStoreApprove(state, data) {
      state.edit_store_approve_list = data;
    },
    setDocumentDetail(state, data) {
      state.documentDetail = data;
    },
    setDocumentList(state, data) {
      state.documentList = data;
    },
    deleteDocumentInList(state, store_id) {
      let index = state.documentList.findIndex(
        (val) => val.store_id == store_id
      );
      state.documentList.splice(index, 1);
    },
    setEventLogApproval(state, data) {
      state.eventLogApproval = data;
    },
    setStoreStatus(state, data) {
      state.storeStatusList = data;
    },
    getDineInStoreList(state, data) {
      state.dine_in_store_list = data;
    },
    getMerchantUser(state, data) {
      state.merchant_user = data;
    },
  },
  actions: {
    async fetchDocumentByContactId({ dispatch }, contact_id) {
      let url = `/${backendVersion.version
        }/merChant/get_contact_merchant_by_id/${contact_id}`;
      return merchantInstance
        .get(url)
        .then((res) => {
          if (res == false) return false;
          return res.data;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async resendEmail({ dispatch }, form) {
      let url = backendVersion.version + "/merChant/bof_resend_email_register";
      let res = await dispatch(
        "fetchGeneral/merchantPostData",
        { url, form },
        { root: true }
      );
      if (res === false) {
        return false;
      } else {
        return true;
      }
    },
    async resetUserPassword({ dispatch }, form) {
      let url = backendVersion.version + "/merChant/bof_reset_password_user";
      let res = await dispatch(
        "fetchGeneral/merchantPostData",
        { url, form },
        { root: true }
      );
      if (res === false) {
        return false;
      } else {
        return true;
      }
    },
    async editEmailByUser({ dispatch }, form) {
      let url = `${backendVersion.version}/merChant/bof_edit_mail_user`;
      let res = await dispatch(
        "fetchGeneral/merchantPutData",
        { url, form },
        {
          root: true,
        }
      );
      if (res === false) {
        return false;
      } else {
        return true;
      }
    },
    async removeUserFromMerchant({ dispatch }, { config, form }) {
      //  /api/v1/phuket/merChant/merchantstore/1630
      let url = `${backendVersion.version}/${config.province
        }/merChant/merchantstore/${config.storeId}`;
      let res = await dispatch(
        "fetchGeneral/merchantPutData",
        { url, form },
        {
          root: true,
        }
      );
      console.log(res.msg);
      if (res === false || res.msg == false) return false;
      return true;
    },
    async getUserInfoByStore({ dispatch }, configPath) {
      let url = `${backendVersion.version}/${configPath.province
        }/merChant/bof_get_store_by_id/${configPath.store_id}`;
      let res = await dispatch("fetchGeneral/merchantGetData", url, {
        root: true,
      });
      if (res === false) {
        return false;
      } else {
        return res.data;
      }
    },
    async getStoreRegistration({ commit, dispatch }, configPath) {
      commit("setStoreStatus", []);
      configPath.province = configPath.province.replace(/ /g, "").toLowerCase();
      let url = `${process.env.VUE_APP_BACKEND_URL_2}/${backendVersion.version
        }/${configPath.province}/merChant/bof_get_store`;
      let res = await dispatch("fetchGeneral/merchantGetData", url, {
        root: true,
      });
      if (res === false) {
        return false;
      } else {
        commit("setStoreStatus", res.data);
        return true;
      }
    },
    async getEventLogApproval({ commit, dispatch }, configPath) {
      commit("setEventLogApproval", []);
      let url = backendVersion.version + "/merChant/get_log_event";
      let res = await dispatch("fetchGeneral/merchantGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("setEventLogApproval", res.data);
        return res;
      }
    },
    async getEventLogAction({ commit, dispatch }, configPath) {
      let url =
        backendVersion.version +
        `/${configPath.province
          .toLowerCase()
          .replace(/ /g, "")}/merChant/get_log_action`;
      return merchantInstance
        .get(url, {
          params: {
            page_size: configPath.page_size,
            current_page: configPath.current_page,
          },
        })
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async verifyHashedUrl({ dispatch }, form) {
      let url = backendVersion.version + "/merChant/verify_hash_url";
      let res = await dispatch(
        "fetchGeneral/merchantPostData",
        { url, form },
        { root: true }
      );
      if (res === false) {
        return false;
      } else {
        return res;
      }
    },
    async approveDocument({ dispatch, commit }, form) {
      let url = backendVersion.version + "/merChant/approve_document";
      let res = await dispatch(
        "fetchGeneral/merchantPostData",
        { url, form },
        { root: true }
      );
      if (res === false) {
        return false;
      } else {
        if (res.msg && res.msg === false) {
          return false;
        }
        commit("deleteDocumentInList", form.store_id);
        return true;
      }
    },
    async rejectDocument({ dispatch, commit }, form) {
      let url = backendVersion.version + "/merChant/reject_document";
      let res = await dispatch(
        "fetchGeneral/merchantPostData",
        { url, form },
        { root: true }
      );
      if (res === false) {
        return false;
      } else {
        if (res.msg && res.msg === false) {
          return false;
        }
        commit("deleteDocumentInList", form.store_id);
        return true;
      }
    },
    async createStoreBank({ dispatch }, { form, province }) {
      let url =
        backendVersion.version + "/" + province + "/merChant/createStoreBank";
      let res = await dispatch(
        "fetchGeneral/merchantPostData",
        { url, form },
        { root: true }
      );
      if (res === false) {
        return false;
      } else {
        return true;
      }
    },
    async uploadBizImage({ dispatch }, { form, province, store_id }) {
      let url =
        backendVersion.version +
        "/" +
        province +
        "/merChant/uploadStoreBusinessImage/" +
        store_id;
      let res = await dispatch(
        "fetchGeneral/merchantPostData",
        { url, form: form },
        { root: true }
      );
      if (res === false) {
        return false;
      } else {
        return true;
      }
    },
    async getDocumentByStore({ commit, dispatch }, { store_id, province }) {
      commit("setDocumentDetail", {});
      let url =
        backendVersion.version +
        "/merChant/get_detail_document?" +
        "store_id=" +
        store_id +
        "&province=" +
        province;
      let res = await dispatch("fetchGeneral/merchantGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("setDocumentDetail", res.data);
        return true;
      }
    },
    async getDocumentList({ commit, dispatch }, configPath) {
      commit("setDocumentList", []);
      let url =
        `${process.env.VUE_APP_BACKEND_URL_2}/` +
        backendVersion.version +
        "/merChant/get_store_document";
      let res = await dispatch("fetchGeneral/merchantGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("setDocumentList", res.data);
        return true;
      }
    },
    async deleteStoreEdit({ commit, dispatch }, store_id) {
      let url =
        backendVersion.version + "/merChant/removeStoreEdit/" + store_id;
      let res = await dispatch("fetchGeneral/merchantDeleteData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("deleteStoreApproveByID", store_id);
        return true;
      }
    },
    async getEditStoreApprove({ commit, dispatch }, province) {
      let url = backendVersion.version + "/merChant/getAllEditStore";
      let res = await dispatch("fetchGeneral/merchantGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("getEditStoreApprove", res.data);
        return res;
      }
    },
    async approveEditStoreApprove({ dispatch, commit }, store_id) {
      let url =
        backendVersion.version + "/merChant/approveEditStoreInfo/" + store_id;
      let res = await dispatch(
        "fetchGeneral/merchantPutData",
        { url, form: {} },
        {
          root: true,
        }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("deleteStoreApproveByID", store_id);
        return true;
      }
    },
    async rejectEditStoreApprove({ dispatch, commit }, data) {
      let url =
        backendVersion.version +
        "/merChant/rejectStoreEdit/" +
        data.config_path.store_id;
      let res = await dispatch(
        "fetchGeneral/merchantPutData",
        { url, form: data.form },
        {
          root: true,
        }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("deleteStoreApproveByID", data.config_path.store_id);
        return true;
      }
    },
    async approveStoreApprove({ dispatch, commit }, data) {
      let url =
        backendVersion.version +
        "/" +
        data.config_path.province +
        "/merChant/approveEditByStoreId/" +
        data.config_path.store_id;
      let res = await dispatch(
        "fetchGeneral/merchantPutData",
        { url, form: data.form },
        {
          root: true,
        }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("approveStoreApprove", data.config_path);
        return true;
      }
    },
    async rejectStoreApprove({ dispatch, commit }, data) {
      let url =
        backendVersion.version +
        "/" +
        data.config_path.province +
        "/merChant/rejectStoreByStoreId/" +
        data.config_path.store_id;
      let res = await dispatch(
        "fetchGeneral/merchantPutData",
        { url, form: data.form },
        {
          root: true,
        }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("approveStoreApprove", data.config_path);
        return true;
      }
    },
    async getStoreDetailByIDAndService({ dispatch }, config_path) {
      let url =
        backendVersion.version +
        "/" +
        config_path.province +
        "/merChant/restaurant/getStoreDetailBackOffice/" +
        config_path.store_id +
        "/" +
        config_path.service;
      let res = await dispatch("fetchGeneral/merchantGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return res;
      }
    },
    async deleteContactStore({ dispatch, commit }, contact_id) {
      let url =
        backendVersion.version +
        "/merChant/reject_contact_document/" +
        contact_id;
      let res = await dispatch("fetchGeneral/merchantDeleteData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("deleteContactStore", contact_id);
        return true;
      }
    },
    async sendContactApprovedEmail({ dispatch }, form) {
      let url = backendVersion.version + "/merChant/send_mail_document";
      let res = await dispatch(
        "fetchGeneral/merchantPostData",
        { url, form },
        { root: true }
      );
      if (res === false) {
        return false;
      } else {
        return true;
      }
    },
    async approveContactNewStore({ dispatch, commit }, payload) {
      let url = backendVersion.version + "/merChant/approve_contact_merchant";
      return merchantInstance
        .post(url, payload)
        .then((res) => {
          commit("approveContactNewStore", payload);
          return true;
        })
        .catch((err) => {
          return false;
        });
    },
    async approveContactOldStore({ dispatch, commit }, payload) {
      let url =
        backendVersion.version + "/merChant/approve_oldstore_contact_merchant";
      let res = await dispatch(
        "fetchGeneral/merchantPutData",
        { url, form: payload },
        { root: true }
      );
      if (res === false) {
        return false;
      } else {
        commit("approveContactOldStore", payload);
        return true;
      }
    },
    async getStoreListByProvince({ dispatch }, province_name) {
      let url =
        backendVersion.version +
        "/" +
        province_name +
        "/merChant/getStoreByProvince";
      let res = await dispatch("fetchGeneral/merchantGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        return res.data;
      }
    },
    async getContactApproveList({ dispatch, commit }) {
      let url =
        `${process.env.VUE_APP_BACKEND_URL_2}/` +
        backendVersion.version +
        "/merChant/getAllContactMerchant";
      let res = await dispatch("fetchGeneral/merchantGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("getContactApproveList", res.data);
        return res.data;
      }
    },
    async approveStore({ commit, rootState, dispatch }, send_data) {
      let url =
        rootState.api_urls.fetchStoreApproveBack_approveStore +
        send_data.store_id;
      delete send_data.store_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: send_data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return "ERROR";
      } else {
        commit("getStoreApproveList", res);
        return "No data available";
      }
    },
    async getStoreApproveList({ commit, dispatch }, province) {
      let url =
        backendVersion.version +
        "/" +
        province +
        "/merChant/getStoreByUsePos/2";
      let res = await dispatch("fetchGeneral/merchantGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("getStoreApproveList", res.data);
        return res;
      }
    },
    async getDineInStoreList({ commit, dispatch }) {
      let url = backendVersion.version + "/dine-in/get/list_store";
      return dineInAxios
        .get(url)
        .then((res) => {
          if (res.msg == false) return [];

          commit("getDineInStoreList", res.data);
        })
        .catch((error) => {
          console.log(error);
          return [];
        });
    },
    async getMerchantUser({ commit, dispatch }) {
      let url = backendVersion.version + "/dine-in/get/list/user_merchant";
      return dineInAxios
        .get(url)
        .then((res) => {
          if (res.msg == false) return [];
          commit("getMerchantUser", res.data);
        })
        .catch((error) => {
          console.log(error);
          return [];
        });
    },
    async updateMerchantUser({ commit, dispatch }, body) {
      let url = backendVersion.version + "/dine-in/manage/store/connect/user";
      return dineInAxios
        .put(url, body)
        .then((res) => {
          return res.msg;
        })
        .catch((error) => {
          return false;
        });
    },
  },
  getters: {
    applyNewUserMerchantData(state) {
      let user_merchant_list = [];
      for (let val of state.merchant_user) {
        user_merchant_list.push({
          ...val,
          user_full_name: `(${val.user_country_tel}${val.user_tel}) - ${val.user_first_name} ${val.user_last_name}`,
        });
      }
      return user_merchant_list;
    },
  },
};
